/* eslint-disable no-unused-vars */
import { IOption } from 'interfaces/TreeFilter';

const getLevel = (searchItem: IOption, options: IOption[], level = 0) => {
  const finded = options.findIndex(item => item.id === searchItem.id) >= 0;

  if (finded) {
    return level;
  }
  const nextLevel = options
    .filter(item => item?.children && item?.children.length > 0)
    .map(item => item?.children || [])
    .flat();

  return getLevel(searchItem, nextLevel, level + 1);
};

const untree = (
  itemTree: IOption[],
  untreeCondition: ((option: IOption) => boolean) | undefined = undefined,
): IOption[] => {
  let accumulator = [] as IOption[];

  itemTree.forEach(item => {
    accumulator = [...accumulator, item];

    if (
      (!untreeCondition || untreeCondition(item)) &&
      item?.children &&
      item?.children?.length
    ) {
      accumulator = [
        ...accumulator,
        ...untree(item?.children, untreeCondition),
      ];
    }
  });

  return accumulator;
};

const getAllParentsByChildren = (
  searchItem: IOption,
  options: IOption[],
): IOption[] | undefined => {
  const findParents = (node: IOption) => {
    let accumulator: IOption[] | undefined;

    if (node.id === searchItem.id) {
      accumulator = [];
    } else if (Array.isArray(node?.children)) {
      node.children.some(treeNode => {
        accumulator = findParents(treeNode);

        if (Array.isArray(accumulator)) {
          accumulator = [treeNode].concat(accumulator);
          return Boolean(accumulator);
        }

        return false;
      });
    }

    return accumulator;
  };

  return findParents({ children: options, id: '' } as IOption);
};

export { untree, getLevel, getAllParentsByChildren };
